module.exports = __webpack_public_path__ + "img/fourthtitle.19ad5501.png";